import { isPosterList, isSquareList } from '../../utils/list';
import { CardWithPointer } from '../../../store/view/types';
import { getCurrentTransmission, getTransmissionSecondaryText } from '../utils';
import { CardList, UiLabel } from '../viewTypes';
import { isCurrentBroadcastCard } from '../../utils/cardProgress';
import { isDetailsCard, isPackageCard } from './presentation';
import { formatLabel } from '../../utils/labels';

type Params = {
  card: CardWithPointer;
  cardList: CardList;
};

type AriaParams = {
  card: CardWithPointer;
  isContinueList: boolean;
  uiLabels: UiLabel[];
};

export const getCardSecondaryText = ({ card, cardList }: Params) => {
  if (isCurrentBroadcastCard(card) && !isSquareList(cardList.style)) {
    const currentTransmission = getCurrentTransmission(card.transmissions);
    return getTransmissionSecondaryText(currentTransmission, card.title);
  }
  if (cardList.isContinueList) {
    return card.description;
  }
  return undefined;
};

export const getCardPrimaryText = ({ card, cardList }: Params) => {
  const listStyle = cardList.style;
  if (
    isPosterList(listStyle) ||
    (isSquareList(listStyle) && !isPackageCard(card.presentation))
  ) {
    return undefined;
  }
  return card.title;
};

export const getCardAriaLabel = ({
  card,
  isContinueList,
  uiLabels,
}: AriaParams) => {
  const ariaLabel: (string | undefined)[] = [];
  ariaLabel.push(uiLabels.map(label => label.text).join(', '));

  if (card.presentation === 'broadcastCard') {
    const service = formatLabel(card, 'broadcastService');
    if (service === 'Yle Areena') {
      ariaLabel.push(
        card.title,
        card.transmissions?.[0]?.title !== card.title
          ? card.transmissions?.[0]?.title
          : undefined
      );
    } else {
      ariaLabel.push(service, card.transmissions?.[0]?.title || card.title);
    }
    return ariaLabel.filter(l => !!l).join(', ');
  }

  ariaLabel.push(card.title);
  if (isContinueList) {
    ariaLabel.push(card.description);
  }
  return ariaLabel.filter(l => !!l).join(', ');
};

export const getLimelightTitle = (card: CardWithPointer) => {
  const detailsCard = card.cards?.find(c => isDetailsCard(c.presentation));
  const currentTransmission = getCurrentTransmission(card.transmissions);
  const limelightTitle =
    detailsCard?.title ??
    (currentTransmission ? currentTransmission.title : card.title);

  return limelightTitle;
};

export const getLimelightDescription = (card: CardWithPointer) => {
  const detailsCard = card.cards?.find(c => isDetailsCard(c.presentation));
  const limelightDescription = detailsCard?.description ?? card.description;
  return limelightDescription;
};

export const combineCardInfo = (
  ...cardInfo: (string | undefined)[]
): string => {
  return cardInfo
    .filter(string => string && string.trim() !== '') // Remove undefined, null, and empty strings
    .join(', ');
};
